var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 34,
    viewBox: "0 0 19 34",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 6.99967V24.4997C15.8333 28.183 12.85 31.1663 9.16667 31.1663C5.48333 31.1663 2.5 28.183 2.5 24.4997V6.99967C2.5 4.69967 4.36667 2.83301 6.66667 2.83301C8.96667 2.83301 10.8333 4.69967 10.8333 6.99967V22.833C10.8333 23.7497 10.0833 24.4997 9.16667 24.4997C8.25 24.4997 7.5 23.7497 7.5 22.833V6.99967H5V22.833C5 25.133 6.86667 26.9997 9.16667 26.9997C11.4667 26.9997 13.3333 25.133 13.3333 22.833V6.99967C13.3333 3.31634 10.35 0.333008 6.66667 0.333008C2.98333 0.333008 0 3.31634 0 6.99967V24.4997C0 29.5663 4.1 33.6663 9.16667 33.6663C14.2333 33.6663 18.3333 29.5663 18.3333 24.4997V6.99967H15.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.cf02fd7b720c91e2a69245cc7ce5d068.svg";
export { ForwardRef as ReactComponent };